<template>
  <div class="card admin">
    <div class="card-header">
      <slot name="header">{{$route.meta.label}}</slot>
    </div>
    <div class="card-block">
      <slot></slot>
    </div>
    <div class="card-header">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AdminCard'
  }
</script>



// WEBPACK FOOTER //
// AdminCard.vue?ef43fa66